"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function forImmediate() {
    return new Promise(function (resolve) {
        setImmediate(function () {
            resolve();
        });
    });
}
exports.forImmediate = forImmediate;
